import styled from 'styled-components';
import { IThemeProps } from 'component/theme';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

export const StyledRadioGroup = styled(RadioGroup)`
  ${({ theme }: IThemeProps) => `
    gap: ${theme.uptimeSpace[5]}px;
    .MuiFormControlLabel-label{
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      text-align: left;
    }
  `};
`;

export const StyledRadio = styled(Radio)<{ theme: IThemeProps, isrow: number }>(({ theme, isrow }) => `
  &.radio-node {
    color: ${theme.uptimeColors.grayScales.darkGray};
    margin: ${isrow ? `${theme.uptimeSpace[0]}px ${theme.uptimeSpace[4]}px` : `${theme.uptimeSpace[4]}px`};
    padding: 0 !important;
    border-radius: 50%;
    &.Mui-checked {
      color: ${theme.uptimeColors.mainTheme.primary} !important;
    }
    .MuiIconButton-label div {
      overflow: visible;
      visibility: visible;
      border-style: none;
      top: 0;
      padding: 0;
      height: auto;
      max-width: unset;
    }
  }
`);